export function checkIfStringStartsWith(str, substrs) {
    return substrs.some(substr => str.startsWith(substr));
}
